export const validIdNumber = new RegExp ("/^\d{2}[0-1][0-9][0-3]\d\d{4}[0-1]\d{2}$/");

export const currencyNumber = (x) => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    let num = parts.join(".");
    return num;
}